import { render } from "./RequisitesBulkEditPopup.vue?vue&type=template&id=649793c2&ts=true"
import script from "./RequisitesBulkEditPopup.vue?vue&type=script&lang=ts"
export * from "./RequisitesBulkEditPopup.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__